import m from "mithril";
import { getUserData } from "../utils.js";

const KasirDashboard = {
    user: null,

    oninit: async function () {
        this.user = await getUserData();
        m.redraw();
    },

    view: function () {
        const user = this.user || {};
        const timeOfDay = new Date().getHours() < 12 ? 'Pagi' : new Date().getHours() < 15 ? 'Siang' : new Date().getHours() < 18 ? 'Sore' : 'Malam';

        return m("div", { class: "max-w-7xl mx-auto p-6" }, [
            // Welcome Section
            m("div", { class: "bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-8 mb-8 text-white shadow-xl relative overflow-hidden" }, [
                m("div", { class: "relative z-10" }, [
                    m("h1", { class: "text-3xl font-bold mb-2" }, `Selamat ${timeOfDay}, ${user.fullName || 'Kasir'}!`),
                    m("p", { class: "text-orange-100 text-lg opacity-90" }, "Selamat datang di Dashboard Kasir. Silakan pilih menu di bawah ini untuk memulai pekerjaan Anda."),
                    m("div", { class: "mt-6 inline-flex items-center bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg" }, [
                        m("i", { class: "ri-store-2-line mr-2" }),
                        m("span", user.subunit_name || "Unit Bisnis")
                    ])
                ]),
                // Decorative circles
                m("div", { class: "absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-white/10 rounded-full blur-3xl" }),
                m("div", { class: "absolute bottom-0 right-20 -mb-20 w-60 h-60 bg-orange-400/20 rounded-full blur-2xl" }),
            ]),

            // Menu Grid
            m("div", { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }, [
                // Card 1: Aktivitas Petugas
                m(m.route.Link, {
                    href: "/petugas-aktivitas",
                    class: "group relative bg-white dark:bg-gray-800 rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-700 hover:-translate-y-1"
                }, [
                    m("div", { class: "absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" }, [
                        m("i", { class: "ri-file-list-3-line text-8xl text-blue-500" })
                    ]),
                    m("div", { class: "relative z-10" }, [
                        m("div", { class: "w-14 h-14 bg-blue-100 dark:bg-blue-900/30 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" }, [
                            m("i", { class: "ri-file-list-3-line text-2xl text-blue-600 dark:text-blue-400" })
                        ]),
                        m("h3", { class: "text-xl font-bold text-gray-900 dark:text-white mb-2" }, "Aktivitas Petugas"),
                        m("p", { class: "text-gray-500 dark:text-gray-400 mb-4" }, "Pantau dan kelola aktivitas harian petugas di lapangan."),
                        m("span", { class: "inline-flex items-center text-blue-600 dark:text-blue-400 font-medium group-hover:translate-x-1 transition-transform" }, [
                            "Buka Menu",
                            m("i", { class: "ri-arrow-right-line ml-2" })
                        ])
                    ])
                ]),

                // Card 2: Setoran Petugas
                m(m.route.Link, {
                    href: "/petugas-setoran",
                    class: "group relative bg-white dark:bg-gray-800 rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-700 hover:-translate-y-1"
                }, [
                    m("div", { class: "absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" }, [
                        m("i", { class: "ri-bank-line text-8xl text-green-500" })
                    ]),
                    m("div", { class: "relative z-10" }, [
                        m("div", { class: "w-14 h-14 bg-green-100 dark:bg-green-900/30 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" }, [
                            m("i", { class: "ri-bank-line text-2xl text-green-600 dark:text-green-400" })
                        ]),
                        m("h3", { class: "text-xl font-bold text-gray-900 dark:text-white mb-2" }, "Setoran Petugas"),
                        m("p", { class: "text-gray-500 dark:text-gray-400 mb-4" }, "Terima setoran dana hasil penagihan dari petugas."),
                        m("span", { class: "inline-flex items-center text-green-600 dark:text-green-400 font-medium group-hover:translate-x-1 transition-transform" }, [
                            "Buka Menu",
                            m("i", { class: "ri-arrow-right-line ml-2" })
                        ])
                    ])
                ]),

                // Card 3: Manajemen Dana
                m(m.route.Link, {
                    href: "/petugas-fund-management",
                    class: "group relative bg-white dark:bg-gray-800 rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-700 hover:-translate-y-1"
                }, [
                    m("div", { class: "absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" }, [
                        m("i", { class: "ri-exchange-funds-line text-8xl text-orange-500" })
                    ]),
                    m("div", { class: "relative z-10" }, [
                        m("div", { class: "w-14 h-14 bg-orange-100 dark:bg-orange-900/30 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" }, [
                            m("i", { class: "ri-exchange-funds-line text-2xl text-orange-600 dark:text-orange-400" })
                        ]),
                        m("h3", { class: "text-xl font-bold text-gray-900 dark:text-white mb-2" }, "Manajemen Dana"),
                        m("p", { class: "text-gray-500 dark:text-gray-400 mb-4" }, "Kelola penitipan dana operasional dan penggantian (reimburse)."),
                        m("span", { class: "inline-flex items-center text-orange-600 dark:text-orange-400 font-medium group-hover:translate-x-1 transition-transform" }, [
                            "Buka Menu",
                            m("i", { class: "ri-arrow-right-line ml-2" })
                        ])
                    ])
                ])
            ]),

            // Quick Info / Footer area
            m("div", { class: "mt-12 border-t border-gray-200 dark:border-gray-700 pt-8" }, [
                m("div", { class: "flex items-center justify-between text-sm text-gray-500 dark:text-gray-400" }, [
                    m("p", "© 2025 Vitta Simpan Pinjam"),
                    m("div", { class: "flex items-center space-x-2" }, [
                        m("span", { class: "w-2 h-2 rounded-full bg-green-500 animate-pulse" }),
                        m("span", "Sistem Aktif")
                    ])
                ])
            ])
        ]);
    }
};

export default KasirDashboard;
